import {
  AddTaskIcon,
  DeleteTaskIcon,
  EditingTaskIcon,
  SearchTaskIcon,
  DownloadButtonIcon,
  CloseButtonModelIcon,
  NotificationOffIconApp,
  NotificationOnIconApp,
  NotificationOffIconAppCard,
  NotificationOnIconAppCard,
} from "./IconsStyles.styled";

export const AddIcon = () => {
  return (
    <>
      <AddTaskIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M23.999 17.331h-6.667v6.667c0 0.354-0.14 0.693-0.391 0.943s-0.589 0.39-0.943 0.39-0.693-0.14-0.943-0.39c-0.25-0.25-0.391-0.589-0.391-0.943v-6.667h-6.667c-0.354 0-0.693-0.14-0.943-0.39s-0.391-0.589-0.391-0.943c0-0.354 0.14-0.693 0.391-0.943s0.589-0.39 0.943-0.39h6.667v-6.667c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391 0.693 0.14 0.943 0.391c0.25 0.25 0.391 0.589 0.391 0.943v6.667h6.667c0.354 0 0.693 0.14 0.943 0.39s0.391 0.589 0.391 0.943c0 0.354-0.14 0.693-0.391 0.943s-0.589 0.39-0.943 0.39z"
        />
      </AddTaskIcon>
    </>
  );
};

export const EditIcon = () => {
  return (
    <>
      <EditingTaskIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#000"
          d="M21.626 2.626l-10.404 10.404c-4.353 4.364-7.65 9.667-9.638 15.502-0.095 0.276-0.11 0.573-0.044 0.857s0.211 0.544 0.419 0.75l0.005 0.005c0.144 0.145 0.316 0.26 0.505 0.339s0.392 0.119 0.596 0.12c0.172-0 0.343-0.029 0.506-0.084 5.835-1.988 11.138-5.284 15.502-9.638l10.404-10.404c1.041-1.041 1.626-2.453 1.626-3.926s-0.585-2.885-1.626-3.926c-0.516-0.516-1.128-0.925-1.801-1.204s-1.396-0.423-2.125-0.423c-1.472 0-2.885 0.585-3.926 1.626zM17.66 19.467c-3.932 3.922-8.669 6.944-13.882 8.859 1.914-5.213 4.937-9.95 8.859-13.882l6.198-6.198 5.023 5.023-6.198 6.198zM28.064 9.064l-2.792 2.792-5.023-5.023 2.792-2.792c0.33-0.331 0.721-0.593 1.152-0.772s0.893-0.272 1.36-0.272c0.467-0 0.929 0.091 1.36 0.27s0.823 0.44 1.154 0.77c0.33 0.33 0.592 0.722 0.77 1.154s0.27 0.894 0.27 1.361-0.093 0.929-0.272 1.36c-0.179 0.431-0.441 0.823-0.772 1.152z"
        />
      </EditingTaskIcon>
    </>
  );
};

export const DeleteIcon = () => {
  return (
    <>
      <DeleteTaskIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M24.401 7.614c-0.123-0.124-0.27-0.222-0.431-0.289s-0.334-0.101-0.509-0.101c-0.175 0-0.348 0.034-0.509 0.101s-0.308 0.165-0.431 0.289l-6.52 6.507-6.52-6.52c-0.123-0.123-0.27-0.221-0.431-0.288s-0.334-0.101-0.509-0.101c-0.175 0-0.347 0.034-0.509 0.101s-0.308 0.165-0.431 0.288c-0.123 0.123-0.221 0.27-0.288 0.431s-0.101 0.334-0.101 0.509c0 0.175 0.034 0.347 0.101 0.509s0.165 0.308 0.288 0.431l6.52 6.52-6.52 6.52c-0.123 0.123-0.221 0.27-0.288 0.431s-0.101 0.334-0.101 0.509c0 0.175 0.034 0.347 0.101 0.509s0.165 0.308 0.288 0.431c0.123 0.123 0.27 0.221 0.431 0.288s0.334 0.101 0.509 0.101 0.347-0.034 0.509-0.101c0.161-0.067 0.308-0.165 0.431-0.288l6.52-6.52 6.52 6.52c0.123 0.123 0.27 0.221 0.431 0.288s0.334 0.101 0.509 0.101 0.347-0.034 0.509-0.101c0.161-0.067 0.308-0.165 0.431-0.288s0.221-0.27 0.288-0.431c0.067-0.161 0.101-0.334 0.101-0.509s-0.034-0.347-0.101-0.509c-0.067-0.161-0.165-0.308-0.288-0.431l-6.52-6.52 6.52-6.52c0.507-0.507 0.507-1.36 0-1.867z"
        />
      </DeleteTaskIcon>
    </>
  );
};

export const SearchIcon = () => {
  return (
    <>
      <SearchTaskIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.667 21.333c-2.422 0-4.472-0.839-6.149-2.517s-2.516-3.728-2.517-6.149c-0.001-2.421 0.838-4.471 2.517-6.149s3.729-2.517 6.149-2.517c2.42 0 4.471 0.839 6.151 2.517s2.519 3.728 2.516 6.149c0 0.978-0.156 1.9-0.467 2.767s-0.733 1.633-1.267 2.3l7.467 7.467c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367l-7.467-7.467c-0.667 0.533-1.433 0.956-2.3 1.267s-1.789 0.467-2.767 0.467zM12.667 18.667c1.667 0 3.084-0.583 4.251-1.749s1.75-2.583 1.749-4.251c-0.001-1.668-0.584-3.084-1.749-4.249s-2.582-1.749-4.251-1.751-3.085 0.582-4.249 1.751c-1.164 1.169-1.748 2.585-1.751 4.249s0.581 3.081 1.751 4.251c1.17 1.17 2.586 1.753 4.249 1.749z" />
      </SearchTaskIcon>
    </>
  );
};

export const DownloadIcon = () => {
  return (
    <>
      <DownloadButtonIcon
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#000"
          d="M16 21.333l-6.667-6.667 1.867-1.933 3.467 3.467v-10.867h2.667v10.867l3.467-3.467 1.867 1.933-6.667 6.667zM8 26.667c-0.733 0-1.361-0.261-1.883-0.783s-0.783-1.15-0.784-1.884v-4h2.667v4h16v-4h2.667v4c0 0.733-0.261 1.361-0.783 1.884s-1.15 0.784-1.884 0.783h-16z"
        />
      </DownloadButtonIcon>
    </>
  );
};

export const CloseButtonIcon = () => {
  return (
    <>
      <CloseButtonModelIcon
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.001 17.867l-6.533 6.533c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933l6.533-6.533-6.533-6.533c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367l6.533 6.533 6.533-6.533c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933l-6.533 6.533 6.533 6.533c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367l-6.533-6.533z" />
      </CloseButtonModelIcon>
    </>
  );
};

export const NotificationOnIcon = () => {
  return (
    <>
      <NotificationOnIconApp
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.668 12c0-2.475 0.983-4.849 2.734-6.6s4.124-2.734 6.6-2.734c2.475 0 4.849 0.983 6.6 2.734s2.734 4.124 2.734 6.6v5.019l2.429 4.859c0.112 0.224 0.165 0.472 0.153 0.722s-0.086 0.493-0.218 0.705c-0.131 0.213-0.315 0.388-0.533 0.51s-0.464 0.186-0.714 0.186h-5.285c-0.297 1.144-0.965 2.158-1.9 2.881s-2.083 1.116-3.266 1.116-2.331-0.393-3.266-1.116c-0.935-0.723-1.603-1.737-1.9-2.881h-5.285c-0.25 0-0.496-0.064-0.714-0.186s-0.402-0.297-0.534-0.51c-0.131-0.213-0.206-0.455-0.218-0.705s0.042-0.498 0.153-0.722l2.429-4.859v-5.019zM13.692 24c0.234 0.405 0.571 0.742 0.976 0.976s0.865 0.357 1.333 0.357c0.468 0 0.928-0.123 1.333-0.357s0.742-0.571 0.976-0.976h-4.619zM16.001 5.333c-1.768 0-3.464 0.702-4.714 1.953s-1.953 2.946-1.953 4.714v5.019c-0 0.414-0.096 0.822-0.281 1.192l-1.56 3.123h17.017l-1.56-3.123c-0.185-0.37-0.282-0.778-0.283-1.192v-5.019c0-1.768-0.702-3.464-1.953-4.714s-2.946-1.953-4.714-1.953z"></path>
      </NotificationOnIconApp>
    </>
  );
};

export const NotificationOffIcon = () => {
  return (
    <>
      <NotificationOffIconApp
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.701 11.239l2.636 2.636v2.829c-0 0.621-0.145 1.234-0.423 1.789l-1.42 2.84h9.301l3.888 3.888c-0.513 0.939-1.296 1.702-2.249 2.19s-2.029 0.679-3.091 0.547c-1.062-0.132-2.059-0.579-2.863-1.285s-1.377-1.637-1.646-2.673h-5.283c-0.25 0-0.496-0.064-0.714-0.186s-0.402-0.297-0.534-0.51c-0.131-0.213-0.206-0.455-0.218-0.705s0.042-0.498 0.153-0.722l2.288-4.577c0.093-0.185 0.141-0.389 0.141-0.596v-4.704c0-0.256 0.010-0.51 0.031-0.761zM16.003 2.667c1.226 0 2.439 0.241 3.572 0.71s2.161 1.157 3.028 2.023c0.867 0.867 1.554 1.896 2.023 3.028s0.71 2.346 0.71 3.572v4.704c-0 0.207 0.048 0.411 0.14 0.596l2.289 4.577c0.112 0.224 0.165 0.472 0.153 0.722s-0.086 0.493-0.218 0.705c-0.131 0.213-0.315 0.388-0.534 0.51s-0.464 0.186-0.714 0.186h-0.568l1.428 1.428c0.243 0.251 0.377 0.588 0.374 0.938s-0.143 0.684-0.391 0.931c-0.247 0.247-0.582 0.387-0.931 0.391s-0.686-0.131-0.938-0.374l-20.741-20.74c-0.127-0.123-0.229-0.27-0.299-0.433s-0.107-0.338-0.108-0.515c-0.002-0.177 0.032-0.353 0.099-0.516s0.166-0.313 0.291-0.438c0.125-0.125 0.274-0.224 0.438-0.291s0.339-0.101 0.516-0.099c0.177 0.002 0.352 0.038 0.515 0.108s0.31 0.171 0.433 0.299l1.857 1.857c0.864-1.201 2.001-2.18 3.318-2.854s2.776-1.026 4.255-1.025zM18.31 24h-4.619c0.234 0.405 0.571 0.742 0.976 0.976s0.865 0.357 1.333 0.357c0.468 0 0.928-0.123 1.333-0.357s0.742-0.571 0.976-0.976zM16.003 5.333c-1.13-0-2.242 0.287-3.231 0.835s-1.822 1.338-2.422 2.296l12.869 12.869h1.293l-1.42-2.84c-0.278-0.555-0.423-1.168-0.423-1.789v-4.704c0-1.768-0.702-3.464-1.953-4.714s-2.946-1.953-4.714-1.953z"></path>
      </NotificationOffIconApp>
    </>
  );
};

export const NotificationOnIconTask = () => {
  return (
    <>
      <NotificationOnIconAppCard
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.668 12c0-2.475 0.983-4.849 2.734-6.6s4.124-2.734 6.6-2.734c2.475 0 4.849 0.983 6.6 2.734s2.734 4.124 2.734 6.6v5.019l2.429 4.859c0.112 0.224 0.165 0.472 0.153 0.722s-0.086 0.493-0.218 0.705c-0.131 0.213-0.315 0.388-0.533 0.51s-0.464 0.186-0.714 0.186h-5.285c-0.297 1.144-0.965 2.158-1.9 2.881s-2.083 1.116-3.266 1.116-2.331-0.393-3.266-1.116c-0.935-0.723-1.603-1.737-1.9-2.881h-5.285c-0.25 0-0.496-0.064-0.714-0.186s-0.402-0.297-0.534-0.51c-0.131-0.213-0.206-0.455-0.218-0.705s0.042-0.498 0.153-0.722l2.429-4.859v-5.019zM13.692 24c0.234 0.405 0.571 0.742 0.976 0.976s0.865 0.357 1.333 0.357c0.468 0 0.928-0.123 1.333-0.357s0.742-0.571 0.976-0.976h-4.619zM16.001 5.333c-1.768 0-3.464 0.702-4.714 1.953s-1.953 2.946-1.953 4.714v5.019c-0 0.414-0.096 0.822-0.281 1.192l-1.56 3.123h17.017l-1.56-3.123c-0.185-0.37-0.282-0.778-0.283-1.192v-5.019c0-1.768-0.702-3.464-1.953-4.714s-2.946-1.953-4.714-1.953z"></path>
      </NotificationOnIconAppCard>
    </>
  );
};

export const NotificationOffIconTask = () => {
  return (
    <>
      <NotificationOffIconAppCard
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.701 11.239l2.636 2.636v2.829c-0 0.621-0.145 1.234-0.423 1.789l-1.42 2.84h9.301l3.888 3.888c-0.513 0.939-1.296 1.702-2.249 2.19s-2.029 0.679-3.091 0.547c-1.062-0.132-2.059-0.579-2.863-1.285s-1.377-1.637-1.646-2.673h-5.283c-0.25 0-0.496-0.064-0.714-0.186s-0.402-0.297-0.534-0.51c-0.131-0.213-0.206-0.455-0.218-0.705s0.042-0.498 0.153-0.722l2.288-4.577c0.093-0.185 0.141-0.389 0.141-0.596v-4.704c0-0.256 0.010-0.51 0.031-0.761zM16.003 2.667c1.226 0 2.439 0.241 3.572 0.71s2.161 1.157 3.028 2.023c0.867 0.867 1.554 1.896 2.023 3.028s0.71 2.346 0.71 3.572v4.704c-0 0.207 0.048 0.411 0.14 0.596l2.289 4.577c0.112 0.224 0.165 0.472 0.153 0.722s-0.086 0.493-0.218 0.705c-0.131 0.213-0.315 0.388-0.534 0.51s-0.464 0.186-0.714 0.186h-0.568l1.428 1.428c0.243 0.251 0.377 0.588 0.374 0.938s-0.143 0.684-0.391 0.931c-0.247 0.247-0.582 0.387-0.931 0.391s-0.686-0.131-0.938-0.374l-20.741-20.74c-0.127-0.123-0.229-0.27-0.299-0.433s-0.107-0.338-0.108-0.515c-0.002-0.177 0.032-0.353 0.099-0.516s0.166-0.313 0.291-0.438c0.125-0.125 0.274-0.224 0.438-0.291s0.339-0.101 0.516-0.099c0.177 0.002 0.352 0.038 0.515 0.108s0.31 0.171 0.433 0.299l1.857 1.857c0.864-1.201 2.001-2.18 3.318-2.854s2.776-1.026 4.255-1.025zM18.31 24h-4.619c0.234 0.405 0.571 0.742 0.976 0.976s0.865 0.357 1.333 0.357c0.468 0 0.928-0.123 1.333-0.357s0.742-0.571 0.976-0.976zM16.003 5.333c-1.13-0-2.242 0.287-3.231 0.835s-1.822 1.338-2.422 2.296l12.869 12.869h1.293l-1.42-2.84c-0.278-0.555-0.423-1.168-0.423-1.789v-4.704c0-1.768-0.702-3.464-1.953-4.714s-2.946-1.953-4.714-1.953z"></path>
      </NotificationOffIconAppCard>
    </>
  );
};
